import { render } from "./FixView.vue?vue&type=template&id=e7624cba&scoped=true"
import script from "./FixView.vue?vue&type=script&lang=js"
export * from "./FixView.vue?vue&type=script&lang=js"

import "./FixView.vue?vue&type=style&index=0&id=e7624cba&lang=scss&scoped=true"

import exportComponent from "/Users/icesea/WebstormProjects/fpcs-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7624cba"]])

export default __exports__